export enum NOTIFICATION_TYPES {
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
  SUCCESS = 'success',
  ATTENTION = 'attention',
}
